import React, {useState} from "react";
import {
    BooleanInput,
    Create,
    Edit,
    FormDataConsumer,
    ImageField,
    ImageInput,
    NumberInput,
    ReferenceArrayInput,
    SelectArrayInput,
    SimpleForm,
    TextInput,
    useNotify,
    fetchStart,
    fetchEnd,
    GET_ONE,
    REDUX_FORM_NAME,
    useDataProvider,
    useMutation,
    CRUD_UPDATE
} from 'react-admin';

import {AsideWithPlayer} from "./generic-aside";
import {Button} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import {useDispatch} from 'react-redux';
import {change} from 'redux-form';

const ScrapeImdb = ({resource, ...other}) => {
    console.info("PROPS:", other, resource);
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [mutate] = useMutation();
    return (
        <FormDataConsumer>{({formData}) => {
            return (
                <Button onClick={() => {
                    setLoading(true);
                    dispatch(fetchStart());
                    dataProvider(GET_ONE, 'imdb', {id: formData.imdb_id}).then(
                        imdb => {

                            if ( imdb.data && imdb.data.poster ) {
                                return fetch(imdb.data.poster)
                                    .then(res => res.ok ? res.blob() : null)
                                    .then(blob => new Promise(resolve => {
                                        const reader = new FileReader();
                                        reader.onload = () => resolve(reader.result);
                                        reader.onerror = () => resolve(null);
                                        reader.readAsDataURL(blob);
                                    }))
                                    .then(base64 => ({
                                        ...imdb,
                                        poster: base64
                                    }))
                                    .catch(err => {
                                        console.error(err);
                                        return imdb;
                                    })
                            } else {
                                return imdb;
                            }
                        })
                        .then(
                        (imdb) => {
                            if (imdb.data && imdb.data.title) {
                                notify('imdb scrape success: ' + imdb.data.title)
                            }
                            setLoading(false);
                            dispatch(fetchEnd());

                            console.info({formData})

                            mutate({
                                    type: 'update',
                                    resource,  // <-----------------
                                    payload: {
                                        id: formData.id,
                                        data: {
                                            id: formData.id,
                                            title: imdb.data.title,
                                            description: imdb.data.story,
                                            crew: [
                                                ...(imdb.data.director || []).map(d => ({
                                                    name: 'director',
                                                    person: {fullname: d}
                                                })),
                                                ...(imdb.data.stars || []).map(d => ({name: 'star', person: {fullname: d}})),
                                                ...(imdb.data.writers|| []).map(d => ({name: 'writer', person: {fullname: d}}))
                                            ],
                                            'cast': (imdb.data.cast || []).map((cast) => ({
                                                character: cast.role,
                                                person: {fullname: cast.name}
                                            })),
                                            poster: { src: process.env.NODE_ENV === 'production' ? imdb.poster : undefined }
                                        }
                                    }
                                }
                            )
                        }
                    ).catch((error) => {
                        console.log("Error!", error);
                        notify('IMDB Scrape Error:' + error.message);
                        setLoading(false);
                        dispatch(fetchEnd());
                    })
                }}
                        type="button"
                    // classes={formData.imdb_id ? 'textPrimary' : 'disabled'}
                        disabled={loading || !formData.imdb_id}
                >
                    Scrape IMDB Data
                </Button>
            );
        }}</FormDataConsumer>
    );
}

const RecordTitle = ({record}) => (
    <span>Record {record ? `"${record.slug || record.name}"` : ''}</span>
);

const MovieForm = (props) => (
    <SimpleForm {...props} fullWidth>


        <Box display="flex" fullWidth>
            <Box flex={1} mr="0.5em">
                <NumberInput label="vendor ID" source="vendor_id" fullWidth/>
            </Box>
            <Box flex={3} mr="0.5em">
                <TextInput readOnly disabled label="slug" source="slug" fullWidth/>
            </Box>
        </Box>


        <TextInput source="title" fullWidth/>
        <TextInput multiline source="description" fullWidth/>

        <ReferenceArrayInput reference="genre" source="genres" label="Genres" allowEmpty>
            <SelectArrayInput optionValue="slug"></SelectArrayInput>
        </ReferenceArrayInput>


        <Box display="flex">
            <Box flex={1} mr="0.5em">
                <BooleanInput label="enabled" source="is_enabled"/>
            </Box>
            <Box flex={1} mr="0.5em">
                <BooleanInput label="deleted" source="deleted" readOnly disabled/>
            </Box>
            <Box flex={1} mr="0.5em">
                <BooleanInput label="audioOnly" source="audioOnly"/>
            </Box>
        </Box>

        <Box display="flex" fullWidth>
            <Box flex={1} mr="0.5em">
                <TextInput label="imdb_id" source="imdb_id"/>
            </Box>
            <Box flex={2} mr="0.5em">
                <ScrapeImdb {...props} />
            </Box>
        </Box>

        <ImageInput source="poster" label="Front Poster" accept="image/png"
                    placeholder={<p>Drop your file here</p>}>
            <ImageField source="url" title="alt"/>
        </ImageInput>

        {/*<TextInput source="poster_download" label="URL to download poster" fullWidth>*/}
        {/*    <ImageField source="poster_download" title="poster preview"/>*/}
        {/*</TextInput>*/}

        <TextInput source="public_url" label="Public stream path" fullWidth/>
        <TextInput label="Legacy stream path part1" source="low_quality_file_id" fullWidth/>
        <TextInput label="Legacy stream path part2" source="high_quality_file_id" fullWidth/>
        <TextInput label="Legacy stream path part0" source="content_host"/>

    </SimpleForm>
);

export const MovieEdit = (props) => (
    <Edit title={<RecordTitle/>}
          aside={<AsideWithPlayer/>}
          {...props}>
        <MovieForm/>
    </Edit>

);


export const MovieCreate = (props) => (
    <Create title={<RecordTitle/>} {...props}>
        <MovieForm/>
    </Create>
);
